// src/utils/navigation.js


export function jumpTo(target) {
    const baseUrl = "https://movieticketsjobs.com";
    
    let url = baseUrl;
    
    if (target === 'register') {
        url = baseUrl + "/#/register";
    }
    
    window.location.href = url;
}